import { Modal } from 'bootstrap'

// Boostrap: Modals
const modalTriggerList = [].slice.call(document.querySelectorAll('.modal'))

modalTriggerList.map((modalTriggerEl) => new Modal(modalTriggerEl))
